import React from 'react';
import { windowTypes, kitchenTypes, parkingTypes, securityFeatures } from '../../lib/constants';
import type { StepProps } from './types';

export default function OptionalDetailsStep({ formData, handleInputChange }: StepProps) {
  return (
    <div className="space-y-6">
      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Type de vitrage
          </label>
          <select
            name="type_vitrage"
            value={formData.type_vitrage}
            onChange={handleInputChange}
            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          >
            <option value="">Sélectionnez le type de vitrage</option>
            {windowTypes.map(({ value, label }) => (
              <option key={value} value={value}>{label}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Type de cuisine
          </label>
          <select
            name="type_cuisine"
            value={formData.type_cuisine}
            onChange={handleInputChange}
            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          >
            <option value="">Sélectionnez le type de cuisine</option>
            {kitchenTypes.map(({ value, label }) => (
              <option key={value} value={value}>{label}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              name="toilettes_separe"
              checked={formData.toilettes_separe}
              onChange={handleInputChange}
              className="w-5 h-5 rounded border-gray-300 
                checked:bg-gradient-to-r checked:from-[#2A4365] checked:via-[#4A5568] checked:to-[#C4A052]
                focus:ring-[#2A4365] focus:ring-offset-2 transition-all duration-300"
            />
            <span className="text-sm text-gray-700">Toilettes séparées</span>
          </label>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Type de parking
          </label>
          <select
            name="type_parking"
            value={formData.type_parking}
            onChange={handleInputChange}
            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          >
            <option value="">Sélectionnez le type de parking</option>
            {parkingTypes.map(({ value, label }) => (
              <option key={value} value={value}>{label}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Sécurité
          </label>
          <div className="space-y-2">
            {securityFeatures.map(({ value, label }) => (
              <label key={value} className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={formData.securite.includes(value)}
                  onChange={(e) => {
                    const newSecurite = e.target.checked
                      ? [...formData.securite, value]
                      : formData.securite.filter(v => v !== value);
                    handleInputChange({
                      target: {
                        name: 'securite',
                        value: newSecurite
                      }
                    } as React.ChangeEvent<HTMLInputElement>);
                  }}
                  className="w-5 h-5 rounded border-gray-300 
                    checked:bg-gradient-to-r checked:from-[#2A4365] checked:via-[#4A5568] checked:to-[#C4A052]
                    focus:ring-[#2A4365] focus:ring-offset-2 transition-all duration-300"
                />
                <span className="text-sm text-gray-700">{label}</span>
              </label>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}